import { unionWith } from "lodash";

import { HealthSurveillanceState } from "./models";
import { HealthSurveillanceAction } from "./actions";
import * as actionTypes from "./actionTypes";

const defaultState: HealthSurveillanceState = { questionnaires: [] };
export const reducer = (state: HealthSurveillanceState = defaultState, action: HealthSurveillanceAction): HealthSurveillanceState => {
    switch (action.type) {
        case actionTypes.LOADED_CLINIC_HEALTH_SURVEILLANCE_QUESTIONNAIRE:
        case actionTypes.SUBMIT_CLINIC_HEALTH_SURVEILLANCE_QUESTIONNAIRE_SUCCESS:
            return {
                ...state,
                questionnaires: unionWith([action.payload], state.questionnaires, (a, b) => a.appointmentId === b.appointmentId)
            };
        default:
            return state;
    }
};
